module.exports = __webpack_public_path__ + "img/q-4@2x.8c5f19b4.png";